import { render } from "./ArrowRightIcon.vue?vue&type=template&id=1f6c2c6c"
const script = {}

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__